import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'
import userTransformer from './transformers/user.transformer'

eventBus.$on(eventDefinitions.USER.LOGGED_IN, ({ user }) => {
  if (!user) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'login',
    login_user_properties: userTransformer(user),
  })
})
